import React, { PropTypes } from 'react';
import VisibleDocuments from './VisibleDocuments';
import CondensedButton from './CondensedButton';

export default class DocumentControl extends React.Component {

	constructor(props) {
		super(props);
		this.state = { showControl: true };
	}

	handleCondensedClick() {
		this.setState({showControl: true});
	}

	handleHideControl() {
		this.setState({showControl: false});
	}

	render () {	
		
		return this.state.showControl 
			? (<VisibleDocuments 
				documents={this.props.documents} 
				selected={this.props.selected} 
				isFetching={this.props.isFetching} 
				getDocumentDetails={this.props.getDocumentDetails}
				getDocumentFiles={this.props.getDocumentFiles}
				resetSelection={this.props.resetSelection}
				downloadFile={this.props.downloadFile}
				onHide={this.handleHideControl.bind(this)}
				hideDocumentsFromMap={this.props.hideDocumentsFromMap}
				setHideDocumentsFromMap={this.props.setHideDocumentsFromMap}
			/>) 
			: <CondensedButton
				tooltip="Mostrar Documentos" 
				className="document-condensed-button" 
				onClick={this.handleCondensedClick.bind(this)} />; 
	}
}

DocumentControl.propTypes = {
	isFetching: PropTypes.bool.isRequired,
	downloadFile: PropTypes.func.isRequired,
	getDocumentDetails: PropTypes.func.isRequired,
	getDocumentFiles: PropTypes.func.isRequired,
	resetSelection: PropTypes.func.isRequired,
	selected: PropTypes.array.isRequired,
	documents: PropTypes.array.isRequired,
	hideDocumentsFromMap: PropTypes.bool.isRequired,
	setHideDocumentsFromMap: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Explorer/DocumentControl.js